<template>
    <div>
        <a
            class="btn btn-md is-primary float-right cursor-pointer hidden xl:flex"
            @click="$modal.show('import-addresses')"
        >
            Ladda upp adressfil
        </a>
        <a
            class="list-item primary-action hidden xl:hidden"
            @click="$modal.show('import-addresses')"
        >
            Ladda upp adressfil
        </a>
        <adaptive-form-modal
            name="import-addresses"
            primary-button-text="Starta import"
            primary-button-class="is-primary"
            title="Ladda upp adresser"
            :redirect-to="redirectRoute"
            :action="actionRoute"
        >
            <div>
                <div class="mb-xl p-xl bg-neutral-lightest text-sm">
                    <p>Observera att filen behöver ha formatet .xslx och innehålla korrekta tabellnamn.</p>
                    <p>Om filen innehåller adresser för lägenheter <i>måste</i> lägenhetsnummer finnas med!</p>
                    <a href="/templates/imports/addresses.xlsx" download>Ladda ned exempelfil.</a>
                </div>

                <input
                    id="file"
                    type="file"
                    name="file"
                    class="hidden"
                    @change="fileSelected"
                >
                <label class="btn is-primary cursor-pointer" for="file">
                    Välj fil
                </label>

                <span class="ml-md text-sm">
                    <span v-if="file">
                        Fil har valts
                    </span>
                    <span v-else>
                        Ingen fil har valts
                    </span>
                </span>

                <checkbox-input
                    v-if="hasSalesPeriod"
                    v-model="addToSalesPeriod"
                    value="1"
                    class="mt-xl mb-sm"
                    name="add_to_sales_period"
                >
                    Lägg till adresserna i aktiv säljomgång
                </checkbox-input>
                <div class="text-xs mt-md">
                    <span>
                        Största tillåtna filstorleken är {{ maxFileSize }}
                    </span>
                </div>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
            group: {
                type: Object,
                required: false,
                default: null,
            },
            hasSalesPeriod: {
                type: Boolean,
            },
        },

        data() {
            return {
                file: null,
                addToSalesPeriod: 1,
            };
        },

        computed: {
            actionRoute() {
                const params = [
                    this.project,
                ];
                if (this.group !== null) {
                    params['group_id'] = this.group.id;
                }

                return route('admin.sales-projects.addresses.import', params);
            },
            redirectRoute() {
                if (this.group !== null) {
                    return route('admin.sales-projects.groups.show', [this.project, this.group]);
                }

                return route('admin.sales-projects.addresses.index', [this.project]);
            },
            maxFileSize() {
                return (window.App && window.App.maxFileSizeImports) ? window.App.maxFileSizeImports : '-';
            },
        },

        methods: {
            fileSelected(e) {
                this.file = e.target.value;
            },
        },
    };
</script>
